import { useTranslation } from "react-i18next";

import { Button } from "../../../../components/Button";
import { useWardLabel } from "../../../../hooks/useWardLabel";
import {
  ButtonContainer,
  Message,
  ModalContainer,
  Title,
} from "./WardPublishedProtocolModal.styles";

type WardPublishedProtocolModalProps = {
  variant: "builder" | "list";
  onClose: () => void;
};

export function WardPublishedProtocolModal({
  variant,
  onClose,
}: WardPublishedProtocolModalProps) {
  const { t } = useTranslation();
  const { singularLower } = useWardLabel();

  const message =
    variant === "builder"
      ? t("protocols_wardPublishedModal_messageBuilder", {
          ward: singularLower,
        })
      : t("protocols_wardPublishedModal_messageList", { ward: singularLower });

  const buttonLabel =
    variant === "builder"
      ? t("protocols_wardPublishedModal_save")
      : t("protocols_wardPublishedModal_ok");

  return (
    <ModalContainer>
      <Title>
        {t("protocols_wardPublishedModal_title", { ward: singularLower })}
      </Title>
      <Message>{message}</Message>
      <ButtonContainer>
        <Button label={buttonLabel} type="button" onClick={onClose} />
      </ButtonContainer>
    </ModalContainer>
  );
}
